import React, { useRef, useEffect, useState } from "react";
import Tree from "react-d3-tree";
import { logData } from "../../utils/genericFunctions";

const transformForD3 = (node) => ({
    name: node.pos_title || "Unknown",
    attributes: { code: node.pos_code || "" },
    data: node,
    children: node.children?.map(transformForD3) || [],
});

const NodeCard = ({ nodeDatum }) => {
    const data = nodeDatum.data;

    return (
        <foreignObject width="220" height="120" x="-110" y="-60">
            <div
                style={{
                    background: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    padding: "10px",
                    width: "200px",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                    textAlign: "center",
                }}
            >
                <strong>{data.pos_title}</strong>
                <br />
                <small style={{ color: "#777" }}>{data.pos_code}</small>
            </div>
        </foreignObject>
    );
};


const BimaOrgChart = ({ hierarchy }) => {
    const treeRef = useRef();
    const containerRef = useRef(null);
    const [dimensions, setDimensions] = useState({ width: 800, height: 600 });



    // Always run hooks
    useEffect(() => {
        if (containerRef.current) {
            const { width, height } = containerRef.current.getBoundingClientRect();
            setDimensions({ width, height });
        }
    }, [hierarchy]);

    // After hooks, render conditionally
    if (!hierarchy || hierarchy.length === 0) {
        return <div>Loading hierarchy...</div>;
    }

    const rootData = transformForD3(hierarchy[0]);



    return (
        <div
            ref={containerRef}
            style={{
                width: "100%",
                height: "100vh",
                border: "0.5px solid #eee",
                borderRadius: "8px",
                overflow: "hidden"
            }}
        >
            <Tree
                ref={treeRef}
                data={rootData}
                translate={{
                    x: dimensions.width / 2,
                    y: 80,
                }}
                zoomable={true}
                collapsible={true}
                separation={{ siblings: 1.5, nonSiblings: 2 }}
                nodeSize={{ x: 220, y: 150 }}
                renderCustomNodeElement={(props) => <NodeCard {...props} />}
                orientation="vertical"
            />
        </div>
    );
};

export default BimaOrgChart;
